import React, { useRef } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  TextField,
  Button,
  IconButton,
  Card,
  CardContent,
  Grid,
  useTheme,
  useMediaQuery,
  LinearProgress,
  Alert,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';
import {
  Image as ImageIcon,
  CloudUpload as UploadIcon,
  History as HistoryIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  CollectionsBookmark as CollectionsBookmarkIcon // LoRA icon
} from '@mui/icons-material';

// ダウンロード用のヘルパー関数を追加
const downloadImage = async (imageUrl, filename) => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('画像のダウンロードに失敗しました:', error);
  }
};

const API_BASE_URL = ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST;  // APIのベースURLを設定

const DEFAULT_PARAMS = {
  mode: "txt2img",
  paymentMethod: "point",
  random: 0,
  count: "1",
  style: "animagineXL40_v40",
  isFullMode: false,
  isFastMode: false,
  isScaleUpx2: false,
  enterJpPrompt: false,
  enterEnhancePrompt: false,
  jpPrompt: "",
  negativePrompt: "(worst quality, bad quality, low quality:1.4),(extra fingers, deformed hands, polydactyl:1.5), (monochrome:1.1),",
  styleP: [],
  styleNP: [],
  sampler: "Euler a",
  upscaler: "R-ESRGAN 4x+ Anime6B",
  steps: "20",
  scale: "4",
  denoisingStrength: "0.35",
  seed: "-1",
  width: "896",
  height: "1152"
};
import Header from '../Header';
import Footer from '../Footer';
import ApiFetch from '../ApiFetch';
import { LanguageCtx, LoginInfo } from '../../App';
import ResolutionDialogTest from './ResolutionSelector';
import ResolutionSelector from './ResolutionSelector';
import { useContext, useEffect, useState } from 'react';
import { analyzeText, containsJapanese, getByteLength, hasMultibyteChar } from '../../service/TextUtil';
import { useTranslation } from 'react-i18next';
import { isLoggin } from '../../service/LoginService';
import ModelSelectorDialog from './ModelSelectorDialog';
import ControlNetPoseEditor from './ControlNetPoseEditor';
import PoseSelectButton from './PosSelectButton';
import ComplexLoading from './ComplexLoading';

const SimpleImageGenerator = () => {
  // ログイン情報
  const { loginInfo, setLoginInfo } = useContext(LoginInfo)
  const { t, i18n } = useTranslation()
  // 言語設定
  const { language, setLanguage } = useContext(LanguageCtx)
  useEffect(() => {
    // ログイン情報取得
    if (loginInfo.length === 0) {
      isLoggin().then(json => {
        setLoginInfo(json)
        if (json.result) {
          i18n.changeLanguage(json.language)
          setLanguage(json.language)
        } else {
          let s = localStorage
          let l = s.getItem("language")
          if (l !== null) {
            i18n.changeLanguage(l)
            setLanguage(l)
            return
          }
          if (window.navigator.language.startsWith("ja")) {
            s.removeItem("language")
            s.setItem("language", "ja")
            i18n.changeLanguage("ja")
            setLanguage("ja")
          } else if (window.navigator.language.startsWith("en")) {
            s.removeItem("language")
            s.setItem("language", "en")
            i18n.changeLanguage("en")
            setLanguage("en")
          }
        }
      })
    }
  }, [loginInfo])

  const [tabValue, setTabValue] = useState(0);
  const poseImage = useRef(null)
  const [prompt, setPrompt] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isColoring, setIsColoring] = useState(false);
  const [isPosing, setIsPosing] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [history, setHistory] = useState([]);
  const [currentProcId, setCurrentProcId] = useState(null);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [generatedImage, setGeneratedImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [resolution, setResolution] = useState({ width: "896", height: "1152" });
  const [selectedModel, setSelectedModel] = useState("animagineXL40_v40"); // モデル選択の状態
  const [selectedLora, setSelectedLora] = useState(""); // LoRA選択の状態
  const [referenceImageThumb, setReferenceImageThumb] = useState(null); // 参考画像のサムネイル
  const [isFastMode, setIsFastMode] = useState(false); // 高速化モード
  const [isFullMode, setIsFullMode] = useState(false); // フル版モード
  const [showModelDialog, setShowModelDialog] = useState(false); // モデル選択ダイアログの表示状態
  const [selectedTool, setSelectedTool] = useState(null); // 選択されたツール

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // APIクライアントのインスタンスを作成
  const apiClient = new ApiFetch();

  // モデルリスト (仮)
  const modelList = [
    { value: "illustriousPencilXL_v200", label: "illustriousPencilXL_v200" },
    { value: "another-model", label: "Another Model" },
    { value: "yet-another-model", label: "Yet Another Model" },
  ];

  // ツールリスト (仮) サムネイルとツール名を定義
  const toolList = [
    /*{
      name: "スタイルを反映する",
      description: "スタイルをモデルに適用した画像を生成します。",
      id: "stylyze",
      thumbnail: "/img/colorize.webp", // TODO: サムネイル画像のURLを設定
    },*/
    {
      name: "白黒画像の彩色",
      description: "白黒の線画に色を付けます。色はプロンプトで指定します。",
      id: "colorize",
      thumbnail: "/img/colorize.webp", // TODO: サムネイル画像のURLを設定
    },
    {
      name: "ポーズ指定",
      description: "ポーズ人形を作成してポーズを指定します。プロンプトと併用が必要です。",
      id: "pose",
      thumbnail: "/img/pose.webp", // TODO: サムネイル画像のURLを設定
    },
    {
      name: "背景削除",
      description: "人物・動物の背景を削除します。",
      id: "rembg",
      thumbnail: "/img/rembg.webp", // TODO: サムネイル画像のURLを設定
    },
    // TODO: 他のツールをここに追加
  ];

  // 履歴を取得する関数
  const fetchHistory = async (page = 1) => {
    setIsLoadingHistory(true);
    try {
      const userId = loginInfo.userId
      const response = await apiClient.get(`${API_BASE_URL}/v1/image/generated/${userId}/${page}`);

      if (!response.ok) throw new Error('履歴の取得に失敗しました');

      const data = await response.json();

      // APIレスポンスを履歴の形式に変換
      const formattedHistory = data.data.map(item => {
        let type = item.mode
        if (item.controlnet_module === 'lineart_anime_denoise') {
          type = 'colorize'
        }
        if (item.controlnet_module === 'None') {
          type = 'pose'
        }
        return {
          id: item.proc_id,
          type: type,
          prompt: item.prompt,
          timestamp: item.create_datetime,
          status: item.status,
          image: `${API_BASE_URL}/v1/sd/getImageSource/${item.proc_id}/2/0`
        }
      })

      setHistory(prev => page === 1 ? formattedHistory : [...prev, ...formattedHistory]);
      setCurrentPage(page);
    } catch (err) {
      setError('履歴の取得中にエラーが発生しました: ' + err.message);
    } finally {
      setIsLoadingHistory(false);
    }
  };

  // コンポーネントマウント時に履歴を取得
  useEffect(() => {
    if (tabValue === 2) {
      fetchHistory(1);
    }
  }, [tabValue]);

  // API呼び出し関数
  const generateImage = async (params) => {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/v1/sd/txt2img`, params);
      if (!response.ok) throw new Error('画像生成リクエストに失敗しました');

      const data = await response.json();
      if (!data.result) throw new Error(data.errors || '画像生成の開始に失敗しました');

      return data.data.procId;
    } catch (err) {
      throw new Error(`画像生成エラー: ${err.message}`);
    }
  };

  // API呼び出し関数
  const removeBackground = async (params) => {
    try {
      const response = await apiClient.post(`${API_BASE_URL}/v1/sd/rembg`, params);
      if (!response.ok) throw new Error('リクエストに失敗しました');

      const data = await response.json();
      if (!data.result) throw new Error(data.errors || '背景削除の開始に失敗しました');

      return data.data.procId;
    } catch (err) {
      throw new Error(`背景削除エラー: ${err.message}`);
    }
  };

  const checkStatus = async (procId) => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/v1/sd/status/${procId}`);
      if (!response.ok) throw new Error('ステータス取得に失敗しました');

      const data = await response.json();
      return {
        status: data.data.status,
        progress: data.data.progress
      };
    } catch (err) {
      throw new Error(`ステータス確認エラー: ${err.message}`);
    }
  };

  const getGeneratedImage = async (procId) => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/v1/sd/getImageSource/${procId}/1/0`);
      if (!response.ok) throw new Error('生成画像の取得に失敗しました');

      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (err) {
      throw new Error(`画像取得エラー: ${err.message}`);
    }
  };

  // 画像生成の監視
  useEffect(() => {
    let intervalId;

    const monitorProgress = async () => {
      if (!currentProcId) return;

      try {
        const statusData = await checkStatus(currentProcId);
        setProgress(statusData.progress);

        if (statusData.status === 3) { // 完了
          const imageUrl = await getGeneratedImage(currentProcId);
          setGeneratedImage(imageUrl);
          setIsGenerating(false);
          setIsColoring(false);
          setIsPosing(false);
          setIsRemoving(false)

          // 履歴を更新
          fetchHistory(1);

          clearInterval(intervalId);
          setCurrentProcId(null);
          setProgress(0);
        }
        if (statusData.status === 4) { //処理失敗
          throw new Error("処理が失敗しました。")
        }
        if (statusData.status === 8 || statusData.status === 9) { //　結果ブロック
          throw new Error("生成結果がブロックされました。")
        }
      } catch (err) {
        setError(err.message);
        setIsGenerating(false);
        setIsColoring(false);
        setIsPosing(false);
        setIsRemoving(false)
        clearInterval(intervalId);
        setCurrentProcId(null);
        setProgress(0);
      }
    };

    if (currentProcId) {
      intervalId = setInterval(monitorProgress, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [currentProcId]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      setSelectedTool(null); // ツールタブに切り替えたらツール選択をリセット
    }
  };

  const handleToolSelect = (toolId) => {
    setSelectedTool(toolId);
  };

  const handleBackToTools = () => {
    setSelectedTool(null); // 「すべてのツール」ボタンでツール選択をリセット
  };


  // 画像生成処理
  const handleGenerate = async () => {
    setError(null);
    setIsGenerating(true);

    try {
      const params = {
        ...DEFAULT_PARAMS,
        prompt: prompt,
        style: selectedModel, // モデル選択を反映
        isFastMode: isFastMode, // 高速化モードを反映
        isFullMode: isFullMode // フル版モードを反映
      };

      params.width = resolution.width + ""
      params.height = resolution.height + ""
      // マルチバイト文字の場合は翻訳する
      if (hasMultibyteChar(prompt)) {
        params.enterJpPrompt = true
        params.jpPrompt = prompt
      }

      console.log("Generate Params:", params); // パラメータをログ出力

      const procId = await generateImage(params);
      setCurrentProcId(procId);
    } catch (err) {
      setError(err.message);
      setIsGenerating(false);
    }
  };

  // 彩色処理
  const handleColorize = async () => {
    setError(null);
    setIsColoring(true);

    try {
      const params = {
        ...DEFAULT_PARAMS,
        prompt: prompt,
        controlnet: 1,
        controlnetModule: "lineart_anime_denoise",
        controlnetModel: "Katarag_lineartXL-fp16 [ac23a680]",
        img: selectedImage,
        style: selectedModel, // モデル選択を反映
        isFastMode: isFastMode, // 高速化モードを反映
        isFullMode: isFullMode // フル版モードを反映
      };
      params.width = resolution.width + ""
      params.height = resolution.height + ""
      // マルチバイト文字の場合は翻訳する
      if (hasMultibyteChar(prompt)) {
        params.enterJpPrompt = true
        params.jpPrompt = prompt
      }
      console.log("Colorize Params:", params); // パラメータをログ出力

      const procId = await generateImage(params);
      setCurrentProcId(procId);
    } catch (err) {
      setError(err.message);
      setIsColoring(false);
    }
  };

  // ポーズ指定処理
  const handlePose = async () => {
    setError(null);
    setIsPosing(true);

    try {
      const params = {
        ...DEFAULT_PARAMS,
        prompt: prompt,
        controlnet: 1,
        controlnetModule: "None",
        controlnetModel: "controlnet-openpose-sdxl-1.0 [d0333a45]",
        img: poseImage.current,
        style: selectedModel, // モデル選択を反映
        isFastMode: isFastMode, // 高速化モードを反映
        isFullMode: isFullMode // フル版モードを反映
      };
      params.width = resolution.width + ""
      params.height = resolution.height + ""
      // マルチバイト文字の場合は翻訳する
      if (hasMultibyteChar(prompt)) {
        params.enterJpPrompt = true
        params.jpPrompt = prompt
      }
      console.log("Colorize Params:", params); // パラメータをログ出力

      const procId = await generateImage(params);
      setCurrentProcId(procId);
    } catch (err) {
      setError(err.message);
      setIsPosing(false);
    }
  };

  // 背景削除処理
  const handleRemoveBackground = async () => {
    setError(null);
    setIsRemoving(true);

    try {
      const params = {
        ...DEFAULT_PARAMS,
        image: selectedImage,
      };
      params.mode = "rembg"

      const procId = await removeBackground(params);
      setCurrentProcId(procId);
    } catch (err) {
      setError(err.message);
      setIsRemoving(false);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        setGeneratedImage(null)
      };
      reader.readAsDataURL(file);
    }
  };

  const handleReferenceImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setReferenceImageThumb(reader.result); // サムネイル用データをセット
      };
      reader.readAsDataURL(file);
    }
  };


  const ImageDropZone = ({ hasImage, onClick, children }) => (
    <Box
      sx={{
        height: 300,
        border: '2px dashed',
        borderColor: 'grey.300',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: hasImage ? 'default' : 'pointer',
        overflow: 'hidden',
        backgroundColor: 'grey.50',
        '&:hover': {
          borderColor: hasImage ? 'grey.300' : 'grey.400'
        }
      }}
      onClick={hasImage ? undefined : onClick}
    >
      {children}
    </Box>
  );

  const ModelSelectDialog = ({ open, onClose, onModelSelect, models, selectedValue }) => (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>モデルを選択</DialogTitle>
      <DialogContent>
        <List>
          {models.map((model) => (
            <ListItem key={model.value} disablePadding>
              <ListItemButton
                selected={selectedValue === model.value}
                onClick={() => {
                  onModelSelect(model.value);
                  onClose();
                }}
              >
                <ListItemText primary={model.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );

  const StylyzeToolContent = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} md={9}> {/* 左側のメインコンテンツ */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="subtitle1">スタイル</Typography>
                  {selectedImage && (
                    <IconButton
                      size="small"
                      onClick={() => setSelectedImage(null)}
                      sx={{ color: 'text.secondary' }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
                <ImageDropZone
                  hasImage={!!selectedImage}
                  onClick={() => document.getElementById('imageInput').click()}
                >
                  <input
                    id="imageInput"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="元の画像"
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <UploadIcon sx={{ width: 48, height: 48, color: 'text.secondary' }} />
                      <Typography color="text.secondary" sx={{ mt: 1 }}>
                        クリックして画像を選択<br />
                        または画像をドラッグ＆ドロップ
                      </Typography>
                    </Box>
                  )}
                </ImageDropZone>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="subtitle1">モデル</Typography>
                  {selectedImage && (
                    <IconButton
                      size="small"
                      onClick={() => setSelectedImage(null)}
                      sx={{ color: 'text.secondary' }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
                <ImageDropZone
                  hasImage={!!selectedImage}
                  onClick={() => document.getElementById('imageInput').click()}
                >
                  <input
                    id="imageInput"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="元の画像"
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <UploadIcon sx={{ width: 48, height: 48, color: 'text.secondary' }} />
                      <Typography color="text.secondary" sx={{ mt: 1 }}>
                        クリックして画像を選択<br />
                        または画像をドラッグ＆ドロップ
                      </Typography>
                    </Box>
                  )}
                </ImageDropZone>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="subtitle1">生成画像</Typography>
                <Box sx={{ position: 'relative' }}>
                  <ImageDropZone hasImage={false}>
                    {selectedImage && generatedImage ? (
                      <>
                        <img
                          src={generatedImage}
                          alt="生成画像"
                          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                        />
                        <Tooltip title="画像をダウンロード">
                          <IconButton
                            sx={{
                              position: 'absolute',
                              right: 8,
                              top: 8,
                              bgcolor: 'rgba(255, 255, 255, 0.8)',
                              '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.9)',
                              }
                            }}
                            onClick={() => downloadImage(generatedImage, `ourt-ai.work_colorized-image-${Date.now()}.webp`)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography color="text.secondary">
                          {isColoring ? <ComplexLoading label={"彩色中…"} /> :
                            selectedImage ? '彩色された画像がここに表示されます' :
                              '左側に画像を選択してください'}
                        </Typography>
                      </Box>
                    )}
                  </ImageDropZone>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {selectedImage && (
            <Button
              variant="contained"
              onClick={handleColorize}
              disabled={isColoring}
              fullWidth
              sx={{ mt: 2 }}
            >
              {isColoring ? '彩色中...' : '彩色を実行'}
            </Button>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={3}> {/* 右側のオプションメニュー (彩色タブ) */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="h6">オプション</Typography>

          {/*<ModelSelectorDialog defaultModel={selectedModel} setModel={setSelectedModel} />*/}
          <Box sx={{ mt: 2 }}>
            <ResolutionSelector onSelect={(resolution) => setResolution(resolution)} />
          </Box>

          <FormControlLabel
            sx={{ display: "none" }}
            control={<Checkbox checked={isFastMode} onChange={(e) => setIsFastMode(e.target.checked)} />}
            label="高速化"
          />
          <FormControlLabel
            sx={{ display: "none" }}
            control={<Checkbox checked={isFullMode} onChange={(e) => setIsFullMode(e.target.checked)} />}
            label="フル版"
          />
        </Box>
      </Grid>
    </Grid>
  );

  const ColorizeToolContent = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} md={9}> {/* 左側のメインコンテンツ */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="subtitle1">元の画像</Typography>
                  {selectedImage && (
                    <IconButton
                      size="small"
                      onClick={() => setSelectedImage(null)}
                      sx={{ color: 'text.secondary' }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
                <ImageDropZone
                  hasImage={!!selectedImage}
                  onClick={() => document.getElementById('imageInput').click()}
                >
                  <input
                    id="imageInput"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="元の画像"
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <UploadIcon sx={{ width: 48, height: 48, color: 'text.secondary' }} />
                      <Typography color="text.secondary" sx={{ mt: 1 }}>
                        クリックして画像を選択<br />
                        または画像をドラッグ＆ドロップ
                      </Typography>
                    </Box>
                  )}
                </ImageDropZone>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="subtitle1">彩色後の画像</Typography>
                <Box sx={{ position: 'relative' }}>
                  <ImageDropZone hasImage={false}>
                    {selectedImage && generatedImage ? (
                      <>
                        <img
                          src={generatedImage}
                          alt="彩色後の画像"
                          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                        />
                        <Tooltip title="画像をダウンロード">
                          <IconButton
                            sx={{
                              position: 'absolute',
                              right: 8,
                              top: 8,
                              bgcolor: 'rgba(255, 255, 255, 0.8)',
                              '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.9)',
                              }
                            }}
                            onClick={() => downloadImage(generatedImage, `ourt-ai.work_colorized-image-${Date.now()}.webp`)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography color="text.secondary">
                          {isColoring ? <ComplexLoading label={"彩色中…"} /> :
                            selectedImage ? '彩色された画像がここに表示されます' :
                              '左側に画像を選択してください'}
                        </Typography>
                      </Box>
                    )}
                  </ImageDropZone>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <TextField
            label="プロンプト"
            multiline
            rows={4}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="生成したい画像の説明を入力してください..."
            fullWidth
            sx={{ mt: 2 }}
          />

          {selectedImage && (
            <Button
              variant="contained"
              onClick={handleColorize}
              disabled={isColoring}
              fullWidth
              sx={{ mt: 2 }}
            >
              {isColoring ? '彩色中...' : '彩色を実行'}
            </Button>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={3}> {/* 右側のオプションメニュー (彩色タブ) */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="h6">オプション</Typography>

          {/*<ModelSelectorDialog defaultModel={selectedModel} setModel={setSelectedModel} />*/}
          <Box sx={{ mt: 2 }}>
            <ResolutionSelector onSelect={(resolution) => setResolution(resolution)} />
          </Box>

          <FormControlLabel
            sx={{ display: "none" }}
            control={<Checkbox checked={isFastMode} onChange={(e) => setIsFastMode(e.target.checked)} />}
            label="高速化"
          />
          <FormControlLabel
            sx={{ display: "none" }}
            control={<Checkbox checked={isFullMode} onChange={(e) => setIsFullMode(e.target.checked)} />}
            label="フル版"
          />
        </Box>
      </Grid>
    </Grid>
  );

  const RemoveBackgroundToolContent = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} md={9}> {/* 左側のメインコンテンツ */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="subtitle1">元の画像</Typography>
                  {selectedImage && (
                    <IconButton
                      size="small"
                      onClick={() => setSelectedImage(null)}
                      sx={{ color: 'text.secondary' }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
                <ImageDropZone
                  hasImage={!!selectedImage}
                  onClick={() => document.getElementById('imageInput').click()}
                >
                  <input
                    id="imageInput"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="元の画像"
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <UploadIcon sx={{ width: 48, height: 48, color: 'text.secondary' }} />
                      <Typography color="text.secondary" sx={{ mt: 1 }}>
                        クリックして画像を選択<br />
                        または画像をドラッグ＆ドロップ
                      </Typography>
                    </Box>
                  )}
                </ImageDropZone>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="subtitle1">背景削除後の画像</Typography>
                <Box sx={{ position: 'relative' }}>
                  <ImageDropZone hasImage={false}>
                    {selectedImage && generatedImage ? (
                      <>
                        <img
                          src={generatedImage}
                          alt="彩色後の画像"
                          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                        />
                        <Tooltip title="画像をダウンロード">
                          <IconButton
                            sx={{
                              position: 'absolute',
                              right: 8,
                              top: 8,
                              bgcolor: 'rgba(255, 255, 255, 0.8)',
                              '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.9)',
                              }
                            }}
                            onClick={() => downloadImage(generatedImage, `ourt-ai.work_bg-removed-image-${Date.now()}.webp`)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography color="text.secondary">
                          {isRemoving ? <ComplexLoading label={"処理中…"} /> :
                            selectedImage ? '処理された画像がここに表示されます' :
                              '左側に画像を選択してください'}
                        </Typography>
                      </Box>
                    )}
                  </ImageDropZone>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {selectedImage && (
            <Button
              variant="contained"
              onClick={handleRemoveBackground}
              disabled={isRemoving}
              fullWidth
              sx={{ mt: 2 }}
            >
              {isRemoving ? '処理中...' : '背景を削除'}
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <div>
      <Box sx={{ mx: 'auto', p: 0 }}>
        <Paper sx={{ p: 1 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            sx={{ mb: 2 }}
          >
            <Tab
              icon={<ImageIcon />}
              label="画像生成"
              iconPosition="start"
            />
            <Tab
              icon={<CollectionsBookmarkIcon />}
              label="ツール"
              iconPosition="start"
            />
            <Tab
              icon={<HistoryIcon />}
              label="履歴"
              iconPosition="start"
            />
          </Tabs>

          {/* タブごとのコンテンツ */}
          {tabValue === 0 && ( // 画像生成タブ
            <Grid container spacing={3}>
              <Grid item xs={12} md={9}> {/* 左側のメインコンテンツ */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ position: 'relative' }}>
                    <ImageDropZone hasImage={false}>
                      {generatedImage ? (
                        <>
                          <img
                            src={generatedImage}
                            alt="生成された画像"
                            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                          />
                          <Tooltip title="画像をダウンロード">
                            <IconButton
                              sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                bgcolor: 'rgba(255, 255, 255, 0.8)',
                                '&:hover': {
                                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                                }
                              }}
                              onClick={() => downloadImage(generatedImage, `ourt-ai.work_generated-image-${Date.now()}.webp`)}
                            >
                              <DownloadIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <Box sx={{ textAlign: 'center' }}>
                          <Typography color="text.secondary">
                            {isGenerating || isPosing ? <ComplexLoading label='画像を生成中…' /> : "生成された画像がここに表示されます"}
                          </Typography>
                        </Box>
                      )}
                    </ImageDropZone>
                  </Box>
                  <TextField
                    label="プロンプト"
                    multiline
                    rows={4}
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    placeholder="生成したい画像の説明を入力してください..."
                    fullWidth
                    sx={{ mt: 2 }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (null !== poseImage.current) {
                        handlePose()
                      } else {
                        handleGenerate()
                      }
                      setGeneratedImage(null)
                    }}
                    disabled={isGenerating || isPosing || !prompt}
                    fullWidth
                  >
                    {isGenerating || isPosing ? '生成中...' : '画像を生成'}
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}> {/* 右側のオプションメニュー */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                  <Typography variant="h6">オプション</Typography>

                  <ModelSelectorDialog defaultModel={selectedModel} setModel={setSelectedModel} />

                  <FormControl fullWidth sx={{ display: "none" }}>
                    <InputLabel id="lora-select-label">LoRA (オプション)</InputLabel>
                    <Select
                      labelId="lora-select-label"
                      id="lora-select"
                      value={selectedLora}
                      label="LoRA (オプション)"
                      onChange={(e) => setSelectedLora(e.target.value)}
                      defaultValue=""
                    >
                      <MenuItem value="">LoRAなし</MenuItem>
                      <MenuItem value="lora-1">LoRA 1</MenuItem> {/* placeholder */}
                      <MenuItem value="lora-2">LoRA 2</MenuItem> {/* placeholder */}
                    </Select>
                  </FormControl>

                  <Button
                    sx={{ display: "none" }}
                    variant="outlined"
                    component="label"
                    startIcon={<CollectionsBookmarkIcon />}
                    fullWidth
                  >
                    参考画像を設定
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleReferenceImageUpload}
                    />
                  </Button>
                  {referenceImageThumb && (
                    <Box sx={{ mt: 1, position: 'relative', display: 'inline-block' }}>
                      <img
                        src={referenceImageThumb}
                        alt="参考画像サムネイル"
                        style={{ maxWidth: '100%', height: 'auto', borderRadius: 1 }}
                      />
                      <IconButton
                        size="small"
                        onClick={() => setReferenceImageThumb(null)}
                        sx={{ position: 'absolute', top: -8, right: -8, bgcolor: 'background.paper' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}

                  <Box sx={{ mt: 2 }}>
                    <ResolutionSelector onSelect={(resolution) => setResolution(resolution)} />
                  </Box>

                  <Box sx={{ mt: 2 }}>
                    <PoseSelectButton onClick={() => { setTabValue(1); setSelectedTool("pose") }} poseImage={poseImage} />
                  </Box>

                  <FormControlLabel
                    sx={{ display: "none" }}
                    control={<Checkbox checked={isFastMode} onChange={(e) => setIsFastMode(e.target.checked)} />}
                    label="高速化"
                  />
                  <FormControlLabel
                    sx={{ display: "none" }}
                    control={<Checkbox checked={isFullMode} onChange={(e) => setIsFullMode(e.target.checked)} />}
                    label="フル版"
                  />
                </Box>
              </Grid>
            </Grid>
          )}

          {tabValue === 1 && ( // ツールタブ
            <Box>
              {selectedTool === null ? ( // ツールが選択されていない場合、ツール選択ボタンを表示
                <Grid container spacing={2} sx={{ p: 1 }}>
                  {toolList.map((tool) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={tool.id}>
                      <Card>
                        <CardContent>
                          <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => handleToolSelect(tool.id)}
                          >
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                              {tool.thumbnail ? (
                                <Box
                                  component="img"
                                  src={tool.thumbnail}
                                  alt={tool.name}
                                  sx={{ width: 240, height: 120, borderRadius: 1, bgcolor: 'grey.200' }} // サムネイル表示
                                />
                              ) : (
                                <Box sx={{ width: 120, height: 120, bgcolor: 'grey.300', borderRadius: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                  <CollectionsBookmarkIcon fontSize="large" color="action" /> {/* デフォルトアイコン */}
                                </Box>
                              )}
                              <Typography variant="caption">{tool.description}</Typography>
                              <Typography variant="subtitle1">{tool.name}</Typography>
                            </Box>
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : ( // ツールが選択されている場合、「すべてのツール」ボタンを表示
                <Box sx={{ p: 1, textAlign: 'left', display: 'none' }}>
                  <Button variant="contained" onClick={handleBackToTools}>
                    すべてのツール
                  </Button>
                </Box>
              )}

              {selectedTool === 'stylyze' && <StylyzeToolContent />}
              {selectedTool === 'colorize' && <ColorizeToolContent />}
              {selectedTool === 'pose' && <ControlNetPoseEditor onSelectImage={(png) => { poseImage.current = png; setTabValue(0); }} />}
              {selectedTool === 'rembg' && <RemoveBackgroundToolContent />}
            </Box>
          )}

          {/* 生成履歴タブ */}
          {tabValue === 2 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {isLoadingHistory && (
                <LinearProgress />
              )}

              {history.map((item) => (
                <Card key={item.id} variant="outlined">
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {item.type === 'txt2img' ? <ImageIcon /> : <UploadIcon />}
                        <Typography variant="subtitle1">
                          {item.type === 'txt2img' ? 'テキストから画像生成' : ''}
                          {item.type === 'img2img' ? '画像から画像生成' : ''}
                          {item.type === 'colorize' ? '彩色' : ''}
                          {item.type === 'pose' ? 'ポーズ指定' : ''}
                          {item.type === 'rembg' ? '背景削除' : ''}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {new Date(item.timestamp).toLocaleString()}
                      </Typography>
                    </Box>

                    {item.status === 3 && (
                      <Box sx={{ position: 'relative' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                          プロンプト: {item.prompt}
                        </Typography>
                        <Box sx={{ position: 'relative' }}>
                          <Box
                            component="img"
                            src={item.image}
                            alt="生成された画像"
                            sx={{
                              width: '100%',
                              height: 300,
                              objectFit: 'contain',
                              bgcolor: 'grey.50',
                              borderRadius: 1
                            }}
                          />
                          <Tooltip title="画像をダウンロード">
                            <IconButton
                              sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                bgcolor: 'rgba(255, 255, 255, 0.8)',
                                '&:hover': {
                                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                                }
                              }}
                              onClick={() => downloadImage(item.image, `ourt-ai.work_history-image-${item.id}.webp`)}
                            >
                              <DownloadIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    )}

                    {item.status !== 3 && (
                      <Typography color="text.secondary">
                        処理中...
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              ))}

              {history.length === 0 && !isLoadingHistory && (
                <Box
                  sx={{
                    textAlign: 'center',
                    py: 6,
                    color: 'text.secondary'
                  }}
                >
                  生成履歴がありません
                </Box>
              )}

              {history.length > 0 && (
                <Button
                  variant="outlined"
                  onClick={() => fetchHistory(currentPage + 1)}
                  disabled={isLoadingHistory}
                  fullWidth
                >
                  {isLoadingHistory ? '読み込み中...' : 'もっと見る'}
                </Button>
              )}
            </Box>
          )}
        </Paper>
      </Box>
      {/* エラー表示の追加 */}
      {error && (
        <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* 進捗表示の追加 */}
      {(isGenerating || isColoring) && progress > 0 && (
        <Box sx={{ width: '100%', mb: 2 }}>
          <LinearProgress variant="determinate" value={progress} />
          <Typography variant="body2" color="text.secondary" align="center">
            {progress}% 完了
          </Typography>
        </Box>
      )}

      <ModelSelectDialog
        open={showModelDialog}
        onClose={() => setShowModelDialog(false)}
        onModelSelect={(model) => setSelectedModel(model)}
        models={modelList}
        selectedValue={selectedModel}
      />

      <Footer />
    </div>
  );
};

export default SimpleImageGenerator;